var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanceltext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50001 5C8.50001 4.44772 8.94772 4 9.50001 4H19.5C20.0523 4 20.5 4.44772 20.5 5V7C20.5 7.55228 20.0523 8 19.5 8C18.9477 8 18.5 7.55228 18.5 7V6H13.3828L13.1173 8.12403C13.0488 8.67206 12.549 9.06078 12.001 8.99228C11.453 8.92378 11.0642 8.42399 11.1327 7.87597L11.3672 6H9.50001C8.94772 6 8.50001 5.55228 8.50001 5ZM3.75671 4.83104C4.12617 4.42053 4.75846 4.38725 5.16897 4.75671L20.169 18.2567C20.5795 18.6262 20.6128 19.2585 20.2433 19.669C19.8738 20.0795 19.2416 20.1128 18.831 19.7433L12.2772 13.8448L11.4923 20.124C11.4238 20.6721 10.924 21.0608 10.376 20.9923C9.82795 20.9238 9.43923 20.424 9.50773 19.876L10.4654 12.2143L3.83104 6.24329C3.42053 5.87384 3.38726 5.24155 3.75671 4.83104Z",
    fill: "#52525B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanceltext);
export default __webpack_public_path__ + "static/media/canceltext.e76ada91193ddf1161f27a54de7b5b5c.svg";
export { ForwardRef as ReactComponent };